import { render, staticRenderFns } from "./PersonalBalanceIncomeLiabilitiesCN.vue?vue&type=template&id=35cc0e38"
import script from "./PersonalBalanceIncomeLiabilitiesCN.vue?vue&type=script&lang=js"
export * from "./PersonalBalanceIncomeLiabilitiesCN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports